module.exports = __webpack_public_path__ + "public/img/dev-num.1871fe8a.gif";